<h1>Metadata dokumentu / poznámka</h1>

<fieldset>
  <strong>Metadata dokumentu</strong>

  <div class="column-100">
    <label>Název dokumentu</label>
    <div class="info">{{ document.name }}</div>

    <label>Číslo jednací dokumentu EPD</label>
    <div class="info">{{ document.referenceNumber || '-'}}</div>

    <label>PID</label>
    <div class="info">{{ document.pid }}</div>

    <label>MPV ID</label>
    <div class="info">{{ document.id }}</div>

    <label>Podoba</label>
    <div class="info">{{ document.analog ? 'Analogová' : 'Digitální' }}</div>

    <label>Počet komponent</label>
    <div class="info">{{ document.components.length }}</div>

    <label>Způsob vytvoření dokumentu</label>
    <div class="info">{{ document.sourceType | documentSourceTypeName }}</div>

    <label>Vytvořeno</label>
    <div class="info">{{ document.timestamp | date : 'short' }}</div>

    <label>Vytvořil</label>
    <div class="info">{{ document.createdUser | username:false:false }}</div>
  </div>
</fieldset>

<fieldset>
  <div class="column-100">
    <label>Poznámka</label>
    <textarea [(ngModel)]="document.note" [disabled]="!canEdit"></textarea>
  </div>
</fieldset>

<div class="text-center pt-20">
  <gmt-button [clickAction]="onUpdate" [gmtDisabled]="!canEdit || !isValid()">Uložit</gmt-button>
  <gmt-button [clickAction]="onCancel" class="red">Zrušit</gmt-button>
</div>
